import { getPaginated } from '@/api/implementation/app/wrapper.js';

export const autocomplete = (...args) => getPaginated(`connector/autocomplete`, ...args);
